import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { AWARD_NODE_FRAGMENT } from '../fragments'

const AWARDS_QUERY = gql`
  query awards {
    awards {
      results {
        ...AwardNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${AWARD_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default AWARDS_QUERY
